module.exports = __webpack_public_path__ + "img/unhappy.1f2bf3cf.png";